export const SIGNUP_LOGIN_ERROR_MESSAGES = {
  userName: '*이름을 입력해주세요.',
  userId: '*아이디를 입력해주세요.',

  pw: [
    '*비밀번호를 입력해주세요.',
    '*비밀번호: 8~16자 영문 대소문자, 숫자를 입력해주세요.',
  ],

  pwCheck: [
    '*비밀번호를 한 번 더 입력해주세요.',
    '*비밀번호가 일치하지 않습니다.',
  ],

  email: ['*이메일을 입력해주세요.', '*이메일 형식을 입력해주세요.'],
  teamName: '*팀을 선택해주세요.',
  partName: '*파트를 선택해주세요.',
};
